import { pushEvent } from '../../../client/data-layer';

export const myProductsItemAdded = (productId: number | string) => {
  pushEvent('myProductsItemAdded', { productId });
};

export const myProductsItemRemoved = (productId: number | string) => {
  pushEvent('myProductsItemRemoved', { productId });
};

export const myProductsOnboardingViewed = () => {
  pushEvent('myProductsOnboardingViewed');
};

export const myProductsListed = () => {
  pushEvent('myProductsListed');
};

export const myProductsImported = () => {
  pushEvent('myProductsImported');
};
